/**
 * @desc InputNum
 */
import React from 'react';
import { Input } from 'antd';
class InputNum extends React.Component {
    constructor() {
        super(...arguments);
        this.handleChange = (value) => {
            this.triggerChange(value);
        };
        this.triggerChange = (value) => {
            const { onChange } = this.props;
            if (onChange) {
                onChange(value);
            }
        };
    }
    render() {
        const { placeholder, value } = this.props;
        return (<div className="flex__row-start">
            <Input onChange={this.handleChange} style={{ width: '40%' }} placeholder={placeholder || '请输入价格'} value={value} suffix="元"/>
            <span style={{ color: '#999' }}>（请输入整百，可为0）</span>
        </div>);
    }
}
export default InputNum;
